import { Link } from 'react-router-dom';

function ServicesPage() {
  return (
    <div>
      <section className="mx-auto max-w-7xl px-4 pb-16 pt-12 md:px-8">
        <span className="text-xs font-bold uppercase tracking-widest text-primary">Nuestras capacidades</span>
        <h1 className="mt-4 max-w-4xl text-4xl font-extrabold leading-tight tracking-tight md:text-6xl">
          Ingeniería de software con precisión arquitectónica.
        </h1>
        <p className="mt-6 max-w-3xl text-lg text-onSurfaceVariant">
          Transformamos visiones complejas en ecosistemas digitales escalables con excelencia
          técnica, diseño sistémico y foco en resultados.
        </p>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-24 md:px-8">
        <div className="grid gap-6 md:grid-cols-12">
          <article className="rounded-2xl bg-white p-8 shadow-sm md:col-span-7">
            <span className="material-symbols-outlined text-primary">cloud</span>
            <h3 className="mt-4 text-3xl font-bold">Cloud Development</h3>
            <p className="mt-3 text-onSurfaceVariant">
              Arquitecturas multi-región sobre AWS y Azure, diseñadas para resiliencia y crecimiento
              continuo.
            </p>
            <ul className="mt-5 space-y-2 text-sm font-medium text-onSurfaceVariant">
              <li>Arquitectura distribuida y escalable.</li>
              <li>CI/CD automatizado con observabilidad.</li>
              <li>Optimización de costos en nube.</li>
            </ul>
          </article>

          <article className="rounded-2xl bg-surfaceContainerLow p-8 md:col-span-5">
            <span className="material-symbols-outlined text-primary">psychology</span>
            <h3 className="mt-4 text-2xl font-bold">AI & Machine Learning</h3>
            <p className="mt-3 text-onSurfaceVariant">
              Modelos de IA aplicados a procesos de negocio, asistentes inteligentes y predicción
              operacional.
            </p>
            <p className="mt-8 text-xs font-bold uppercase tracking-widest text-onSurfaceVariant">
              Equipo especializado en LLM y automatización avanzada
            </p>
          </article>

          <article className="rounded-2xl bg-inverseSurface p-8 text-inverseOnSurface md:col-span-5">
            <p className="text-xs font-bold uppercase tracking-widest text-primary">iOS + Android</p>
            <h3 className="mt-4 text-3xl font-bold">Ecosistemas móviles</h3>
            <p className="mt-3 text-inverseOnSurface/70">
              Desarrollamos experiencias nativas y multiplataforma para crecimiento digital y
              fidelización.
            </p>
            <Link to="/contacto" className="mt-6 inline-block rounded-md bg-primary px-5 py-3 text-sm font-bold text-white">
              Ver portafolio móvil
            </Link>
          </article>

          <article className="rounded-2xl bg-surfaceContainerHighest p-8 md:col-span-7 md:flex md:items-center md:justify-between md:gap-8">
            <div>
              <span className="material-symbols-outlined text-primary">architecture</span>
              <h3 className="mt-4 text-2xl font-bold">Consultoría estratégica</h3>
              <p className="mt-3 text-onSurfaceVariant">
                Auditoría de arquitectura, evolución tecnológica y roadmap de ejecución.
              </p>
            </div>
            <div className="mt-6 rounded-xl bg-white/60 p-5 md:mt-0 md:w-60">
              <p className="text-3xl font-extrabold text-primary">98%</p>
              <p className="text-xs font-bold uppercase tracking-widest text-onSurfaceVariant">
                eficiencia en entregas
              </p>
              <div className="mt-4 h-1.5 overflow-hidden rounded-full bg-slate-200">
                <div className="h-full w-[98%] bg-primary" />
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="bg-surfaceContainerLow py-24">
        <div className="mx-auto grid max-w-7xl items-center gap-16 px-4 md:grid-cols-2 md:px-8">
          <div>
            <h2 className="text-3xl font-extrabold tracking-tight md:text-4xl">
              Metodología de ingeniería de alta fidelidad.
            </h2>
            <p className="mt-4 text-onSurfaceVariant">
              Eliminamos incertidumbre con discovery técnico, sprints de entrega y QA riguroso.
            </p>
            <ol className="mt-8 space-y-5">
              <li className="flex gap-4">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white font-bold text-primary">1</span>
                <div>
                  <p className="font-bold">Discovery & Blueprint</p>
                  <p className="text-sm text-onSurfaceVariant">Mapeo de necesidades y arquitectura objetivo.</p>
                </div>
              </li>
              <li className="flex gap-4">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white font-bold text-primary">2</span>
                <div>
                  <p className="font-bold">Sprints ágiles</p>
                  <p className="text-sm text-onSurfaceVariant">Iteraciones cortas con visibilidad total del avance.</p>
                </div>
              </li>
              <li className="flex gap-4">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white font-bold text-primary">3</span>
                <div>
                  <p className="font-bold">QA + Lanzamiento</p>
                  <p className="text-sm text-onSurfaceVariant">Pruebas profundas antes de cada despliegue.</p>
                </div>
              </li>
            </ol>
          </div>
          <div className="relative">
            <div className="overflow-hidden rounded-2xl border-4 border-white shadow-xl">
              <img
                src="/assets/images/services/consultores.png"
                alt="Consultores de software"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 hidden max-w-xs rounded-xl bg-primary p-6 text-white shadow-xl md:block">
              <p className="text-sm italic">
                "La calidad técnica de Krystal puede ser clave para escalar productos a decenas de usuarios."
              </p>
              <p className="mt-4 text-xs font-bold uppercase tracking-widest">{"< -- >"}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-24 md:px-8">
        <div className="rounded-2xl bg-gradient-to-r from-[#0078b8] via-[#2797d3] to-[#6fb7df] p-12 text-center text-white">
          <h2 className="text-3xl font-extrabold md:text-5xl">¿Listo para construir el siguiente nivel?</h2>
          <p className="mx-auto mt-4 max-w-2xl text-white/85">
            Definamos una arquitectura tecnológica que impulse resultados sostenibles en tu negocio.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link to="/contacto" className="rounded-md bg-primary px-7 py-3 font-bold text-white">
              Programar consulta
            </Link>
            <Link to="/por-que-nosotros" className="rounded-md border border-white/50 px-7 py-3 font-bold">
              Ver por qué Krystal
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ServicesPage;
